/**
 * RootLayout — top-level shell.
 *
 * Sticky header (brand + contextual chrome by mode), body Outlet, footer.
 * Studio mode shows the workspace switcher; rehearsal mode shows the
 * "Rehearsal" badge; theme toggle is always present.
 */

import { Outlet } from "react-router-dom";

import Footer from "@/components/chrome/Footer";
import Header from "@/components/chrome/Header";
import ThemeToggle from "@/components/chrome/ThemeToggle";
import WorkspaceSwitcher from "@/components/chrome/WorkspaceSwitcher";
import { useAuth } from "@/contexts/auth/AuthContext";
import { ModeProvider, useMode } from "@/contexts/mode/ModeContext";

const REHEARSAL_BADGE = "Rehearsal";

export default function RootLayout() {
  return (
    <ModeProvider>
      <RootLayoutInner />
    </ModeProvider>
  );
}

function RootLayoutInner() {
  const { mode } = useMode();
  const { user } = useAuth();
  const ws = user?.workspaceSlug ? { slug: user.workspaceSlug, name: user.workspaceSlug } : null;

  return (
    <div
      data-testid="layout-root"
      data-mode={mode}
      className="bg-stage-carbon"
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header
        right={
          <>
            {mode === "rehearsal" ? (
              <span
                data-testid="rehearsal-badge"
                className="font-plex-mono text-paper-cream"
                style={{
                  padding: "4px 10px", fontSize: "0.781rem",
                  background: "var(--rehearsal-taupe)",
                  border: "1px solid var(--brass-bezel)",
                  borderRadius: "var(--radius)", letterSpacing: "0.04em",
                }}
              >{REHEARSAL_BADGE}</span>
            ) : null}
            {mode === "studio" ? <WorkspaceSwitcher currentWorkspace={ws} /> : null}
            <ThemeToggle />
          </>
        }
      />
      <main style={{ padding: "32px 24px", flex: 1 }}><Outlet /></main>
      <Footer />
    </div>
  );
}
